import apiFetch from '../apiFetch'

export default function (token, organizedUnitSaleOperation) {
  return apiFetch({ endPoint: 'OrganizedUnitSaleOperation', method: 'POST', body: organizedUnitSaleOperation, token: token })
}
